export default __webpack_public_path__ + "static/wemoney-pl-cs-2022-ad4609e6c456f35ee8098c1457faba31.svg";